import { type PropsWithChildren, type FunctionComponent } from 'react'
import { DashRoute } from '../../../legacy/dash-components/dash-route/DashRoute'
import { DashSwitch } from '../../../legacy/dash-components/dash-switch/DashSwitch'
import { useCurrentAccountContext } from '../../../utils/current-account/CurrentAccountContext'
import { HaltTerms } from '../../../sections/halt/components/terms/HaltTerms'
import { RetailerScopedSection } from './retailer-scoped/RetailerScopedSection'
import { PartnerScopedRoutes } from './PartnerScopedRoutes'
import { PartnerScopedChrome } from './PartnerScopedChrome'
import { PartnerTermsGate } from './PartnerTermsGate'

interface Props {
  pathname: string
}

export const PartnerScopedApp: FunctionComponent<PropsWithChildren<Props>> = ({ pathname }) => {
  const { refetch } = useCurrentAccountContext()

  return (
    <PartnerTermsGate pathname={pathname}>
      <DashSwitch>
        <DashRoute
          route="partner-halt-terms"
          render={() => <HaltTerms refetchCurrentAccount={refetch} />}
          exact
        />
        <DashRoute
          route="partner-scoped"
          render={() => (
            <PartnerScopedChrome pathname={pathname}>
              <DashSwitch>
                <DashRoute route="retailer-scoped" component={RetailerScopedSection} />
                <PartnerScopedRoutes />
              </DashSwitch>
            </PartnerScopedChrome>
          )}
        />
      </DashSwitch>
    </PartnerTermsGate>
  )
}
